import {
  getDeviceAndNetworkInfo,
  getPageLoadTime,
  getTimeToInteract,
} from './cplHelperFunctions';
import type { GenericObjectType } from '@/types';
import type { LoggerType } from '@/lib/logger/logger';

export default function logPerformance(
  this: LoggerType,
  customParams: GenericObjectType,
): void {
  try {
    if (!window?.PAYPAL?.analytics?.logPerformance) {
      return;
    }
    const deviceAndNetworkInfo = getDeviceAndNetworkInfo();
    const { timeToInteract, ...restParams } = customParams;
    const data = {
      ...restParams,
      tt: getPageLoadTime(), // page load time
      view: {
        bh: deviceAndNetworkInfo?.screen_height, // browserHeight
        bw: deviceAndNetworkInfo?.screen_width, // browserWidth
        cd: window.screen.colorDepth, // screenColorDepth
        dh: window.screen.height * (window.devicePixelRatio || 1), // deviceHeight
        dw: window.screen.width * (window.devicePixelRatio || 1), // deviceWidth
        et: deviceAndNetworkInfo?.network_effectiveType, // network connection type
        pt: document.title, // page title
        ru: document.referrer, // referrer
        sh: window.screen.height, // screenHeight
        sw: window.screen.width, // screenWidth
        t11: timeToInteract || getTimeToInteract(), // time to interact
      },
    };

    window.PAYPAL.analytics.logPerformance(data);
  } catch (e) {
    this.error('ERROR_IN_POPULATING_LOG_PERFORMANCE_DATA', {
      error: e,
    });
  }
}
